// module for fixing the duplicate footer in employees view
import { queryAll } from './utils'

;(function () {
  Drupal.behaviors.betterExposedFilters = {
    attach: function () {
      // hardcoded footer node id
      const footerArticles = queryAll('article[data-history-node-id="31"]')
      
      if (footerArticles.length > 1) {
        footerArticles[0].remove()
      }
    },
  }
})()
